export default function IconEmbrio({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M21 13.5398L18.8625 14.8713L15.87 13.5398L12.4501 15.7591L9.45757 13.0959C9.45757 13.0959 11.5951 11.8707 11.5951 10.0952C11.5951 8.3198 9.88506 3.77482 5.61009 4.66254C1.33511 5.55026 1.67874 10.4333 2.53373 11.7649C3.38873 13.0965 5.61009 14.8713 5.61009 14.8713C5.61009 14.8713 6.03759 21.5299 11.5951 21.9737C17.1525 22.4176 17.1525 17.0913 17.1525 17.0913M20.5796 2C12.0296 2 14.8442 10.5714 14.8442 10.5714"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
